import { render, staticRenderFns } from "./RefsUploadModal.vue?vue&type=template&id=51ad4bf6&scoped=true&"
import script from "./RefsUploadModal.vue?vue&type=script&lang=js&"
export * from "./RefsUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./RefsUploadModal.vue?vue&type=style&index=0&id=51ad4bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ad4bf6",
  null
  
)

export default component.exports